// Central registry of Unleash feature flag names used by the app
export const FeatureFlags = {
    middagstipsV1: "middagstips-v1",
    useBonusToCharityTvAksjonen: "use-bonus-to-charity-tv-aksjonen",
} as const

export type FeatureFlagName = (typeof FeatureFlags)[keyof typeof FeatureFlags]
